import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors, dimensions } from "@styles";

export const boxSection = css`
  padding: 0.5rem 0.625rem;
  font-weight: ${typography.weightBold};
  display: flex;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
    align-items: center;

    padding: 0.5rem;
  }
`;

export const circleIcon = css`
  color: ${colors.primary};
  margin-right: 0.5rem;
`;

export const doubleSection = css`
  color: ${colors.primary};
  margin-left: 2rem;
  margin-right: 0.5rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 0;
  }
`;

export const storeOffer = css`
  display: flex;
  align-items: center;

  text-align: center;
`;

export const pill = css`
  margin-bottom: 1rem;
`;
